import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import RiskRegisterUpdateModalUI from './RiskRegisterUpdateModalUI.js'

class RiskRegisterUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      ownerUserId: this.props.selectedRisk && this.props.selectedRisk.ownerUserId || '',
      ownerUserIdError: null,
      status: this.props.selectedRisk && this.props.selectedRisk.status || '',
      statusError: null,
      mitigationPlan: this.props.selectedRisk && this.props.selectedRisk.mitigationPlan || '',
      mitigationPlanError: null,
      remarks: this.props.selectedRisk && this.props.selectedRisk.remarks || '',
      remarksError: null,
      riskResponse: this.props.selectedRisk && this.props.selectedRisk.riskResponse || '',
      riskResponseError: null,
      probability: this.props.selectedRisk && this.props.selectedRisk.probability || '',
      probabilityError: null,
      impact: this.props.selectedRisk && this.props.selectedRisk.impact || '',
      impactError: null,
      riskLevel: this.props.selectedRisk && this.props.selectedRisk.riskLevel || '',
      riskLevelError: null,
    }
  }

  render() {
    let statusList = [
      { key: 'active', value: 'Active' },
      { key: 'materialized', value: 'Materialized' },      
      { key: 'mitigated', value: 'Mitigated' }
    ]
    
    let riskResponseList = [
      { key: 'reduce', value: 'Reduce' },
      { key: 'accept', value: 'Accept' },
      { key: 'avoid', value: 'Avoid' },
      { key: 'transfer', value: 'Transfer' },
      { key: 'escalate', value: 'Escalate' }
    ]
    let riskLevelList = [
      { key: 'high', value: 'High' },
      { key: 'medium', value: 'Medium' },
      { key: 'low', value: 'Low' }
    ]
    let probabilityList = [
      { key: 'likely', value: 'Likely' },
      { key: 'unlikely', value: 'Unlikely' }
    ]
    let impactList = [
      { key: 'minor', value: 'Minor' },
      { key: 'moderate', value: 'Moderate' },
      { key: 'severe', value: 'severe' }
    ]
    return (
      <RiskRegisterUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        ownerUserId={this.state.ownerUserId}
        onOwnerUserIdChange={(event) => { this.setState({ ownerUserId: event.target.value }) }}
        ownerUserIdError={this.state.ownerUserIdError}
        setOwnerUserIdError={(error) => { this.setState({ ownerUserIdError: error }) }}
        ownerUserIdList={this.state.assignedUserIdList}
        //
        status={this.state.status}
        onStatusChange={(event) => { this.setState({ status: event.target.value }) }}
        statusError={this.state.statusError}
        setStatusError={(error) => { this.setState({ statusError: error }) }}
        statusList={statusList}
        //
        mitigationPlan={this.state.mitigationPlan}
        onMitigationPlanChange={(event) => { this.setState({ mitigationPlan: event.target.value }) }}
        mitigationPlanError={this.state.mitigationPlanError}
        setMitigationPlanError={(error) => { this.setState({ mitigationPlanError: error }) }}
        //
        remarks={this.state.remarks}
        onRemarksChange={(event) => { this.setState({ remarks: event.target.value }) }}
        remarksError={this.state.remarksError}
        setRemarksError={(error) => { this.setState({ remarksError: error }) }}

        riskLevel={this.state.riskLevel}
        onRiskLevelChange={(event) => { this.setState({ riskLevel: event.target.value }) }}
        RiskLevelError={this.state.riskLevelError}
        setRiskLevelError={(error) => { this.setState({ riskLevelError: error }) }}
        riskLevelList={riskLevelList}

        riskResponse={this.state.riskResponse}
        onRiskResponseChange={(event) => { this.setState({ riskResponse: event.target.value }) }}
        RiskResponseError={this.state.riskResponseError}
        setRiskResponseError={(error) => { this.setState({ riskResponseError: error }) }}
        riskResponseList={riskResponseList}

        probability={this.state.probability}
        onProbabilityChange={(event) => {this.setState({ probability: event.target.value }) }}
        probabilityError={this.state.probabilityError}
        setProbabilityError={(error) => { this.setState({ probabilityError: error }) }}
        probabilityList={probabilityList}

        impact={this.state.impact}
        onImpactChange={(event) => {this.setState({ impact: event.target.value }) }}
        impactError={this.state.impactError}
        setImpactError={(error) => { this.setState({ impactError: error }) }}
        impactList={impactList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    this.getSuperUsers(context)
  }

  getSuperUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers`,
      cacheKey: CacheKeys.SuperUsers(),
      callback: this.getSuperUsersCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getSuperUsersCallback = (response) => {
    console.log(response.userList)
    let assignedUserIdList = response.userList.map((user, index) => {
      return { key: user.userId, value: user.addressableName };
    });
    this.setState({ errorList: response.errorList, assignedUserIdList: assignedUserIdList })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/riskRegisters/riskCodes/${this.props.selectedRisk.riskCode}/year/${this.props.year}/month/${this.props.month}`,
      this.onSubmitCallback, {
      ownerUserId: this.state.ownerUserId,
      status: this.state.status,
      mitigationPlan: this.state.mitigationPlan,
      remarks: this.state.remarks,
      riskResponse: this.state.riskResponse,
      riskLevel: this.state.riskLevel,
      probability: this.state.probability,
      impact: this.state.impact
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(RiskRegisterUpdateModalSF)
